import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, IconButton, Typography } from '@material-ui/core';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PageMetadata from '../PageMetadata';

/**
 * Layout para páginas de documentação das APIs.
 * Exibe botão voltar (ícone) ao lado do título e retorna para /messages-api.
 */
const ApiDocLayout = ({ children, title = '', subtitle, backTo = '/messages-api' }) => {
  const history = useHistory();

  return (
    <Box>
      <PageMetadata title={title} />
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        flexWrap="wrap"
        gap={2}
        marginBottom={3}
      >
        <IconButton
          onClick={() => history.push(backTo)}
          color="primary"
          size="medium"
          style={{ marginRight: 12 }}
          aria-label="Voltar"
        >
          <ArrowBackIcon />
        </IconButton>
        <Box>
          <Typography component="h1" variant="h3" style={{ fontWeight: 600 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="subtitle1" color="textSecondary">
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      {children}
    </Box>
  );
};

export default ApiDocLayout;
